module.exports = __webpack_public_path__ + "images/2ff5aeae54ed119b37740c11329166db-welcome.jpg";